/***
 *
 *   HOMEPAGE
 *   Org subdomains get that organization's page; the apex domain gets the
 *   marketing landing page.
 *
 **********/

import React from 'react';
import { getSubdomain } from 'utilities/routes';
import { AccountPage } from 'views/website/account/main';
import { Landing } from 'views/website/landing/landing';

export function Home(props) {
    const subdomain = getSubdomain(props);

    return subdomain ? <AccountPage subdomain={subdomain} /> : <Landing />;
}
